'use strict';

/**
 * Base Border Radii:
 *
 * Euclid DS allowed border radii: smaller subset of TW defaults.
 */ const borderRadius = {
    none: '0',
    xs: '0.25rem',
    sm: '0.375rem',
    md: '0.75rem',
    lg: '1rem',
    full: '9999px'
};

exports.borderRadius = borderRadius;
//# sourceMappingURL=borderRadius.js.map
